import React, { useState, useEffect } from "react";

import {
  Paper,
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Box,
  CircularProgress,
  Pagination,
} from "@mui/material";
import axios from "axios";
import Styles from "../../styles/vendorDashboard.module.css";
import { Search } from "../../shared/assets/icons";

const getHeadCells = [
  { id: "campaignName", label: "CAMPAIGN NAME", width: 100 },
  { id: "dateInitiated", label: "DATE INITIATED", width: 100 },
  { id: "generatedBy", label: "GENERATED BY", width: 120 },
  { id: "timeline", label: "TIMELINE", width: 160 },
  { id: "campaign-owner", label: "CAMPAIGN OWNER", width: 160 },
  { id: "kam", label: "KAM", width: 120 },
  { id: "quantity", label: "QUANTITY", width: 100 },
  { id: "budget", label: "BUDGET", width: 100 },
  { id: "progress", label: "PROGRESS", width: 80 },
  { id: "status", label: "STATUS", width: 100 },
];

function EnhancedTableHead(props) {
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    setHeadCells(getHeadCells);
  }, []);

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            sx={{
              minWidth: headCell.width,
              height: 90,
            }}
            key={index}
          >
            <span className="absolute top-5 text-[13px] font-semibold bg-[var(--secondary-color)]">
              {" "}
              {headCell.label}{" "}
            </span>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
var oldData = [];

const ClientCampaignsTable = () => {
  const serverURL = process.env.REACT_APP_URL;

  const clientId = localStorage.getItem("clientId");
  const [kamdata, setKamdata] = useState([]);
  const [selectedCampaignKamId, setSelectedCampaignKamId] = useState(null);

  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isOrganizationId, setIsOrganizationId] = useState("");

  const [campaign, setCampaign] = useState([]);

  const [campaignListLoading, setCampaignListLoading] = useState(true);
  const [totalCampaign, setTotalCampaign] = useState("0");

  const [searchInputs, setSearchInputs] = useState({
    campaignName: "",
  });
  const getCampaignList = async (page = 1, limit = 20, organizationId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/campaign/allCampaigns?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            organizationId: organizationId,
          },
        }
      );
      if (response?.data?.success) {
        setTotalCampaign(response?.data?.data.length);
        setCampaign(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setKamdata(response?.data?.adminsData);
        oldData = response?.data?.data;
        setCampaignListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  const handlePageChange = async (e, value) => {
    await getCampaignList(value, pageSize, isOrganizationId);
    setPage(value);
  };
  useEffect(() => {
    getCampaignList(page, pageSize, isOrganizationId);
  }, [page, pageSize]);

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setPage(1);
  };

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value;
    const searchTerm = value.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    const searchKeyword = new RegExp(`\\b${searchTerm}\\w*\\b`, "i");
    // Update search inputs state for that particular field
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    // Check if the input is empty and reset the data to oldData
    if (searchKeyword === "") {
      setCampaign(oldData);
    } else {
      // Apply filtering based on the column (key)
      const filteredData = oldData.filter((data) => {
        // For each case, check if the key matches and perform filtering
        switch (key) {
          case "campaignName":
            return searchKeyword.test(data?.campaignTitle?.toLowerCase());

          default:
            return true;
        }
      });

      setCampaign(filteredData); // Update the campaign with the filtered data
    }
  };
  const getKAMName = (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return "No KAM Assigned";

    // Map through IDs and find corresponding KAM details
    const kamDetails = ids
      .map((id) => {
        const kam = kamdata.find((kam) => kam._id === id);
        return kam ? { name: kam.name, email: kam.email } : null;
      })
      .filter((kam) => kam !== null); // Remove null values

    return kamDetails;
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // short month format (e.g., Oct)
    const year = date.getFullYear().toString().slice(-2); // last two digits of the year

    return `${day} ${month} ${year}`;
  };
  let organizationId;

  const clientDetails = async (clientId) => {
    try {
      const userDetails = await axios.get(
        `${serverURL}/client/dashboard/${clientId}`
      );
      if (userDetails.data.success) {
        organizationId = userDetails.data.data.organizationId;
        let page = 1;
        let limit = 20;

        getCampaignList(page, limit, organizationId);
        setIsOrganizationId(organizationId);
      }
    } catch (error) {
      console.error("error in getting user details", error);
    }
  };

  useEffect(() => {
    clientDetails(clientId);
  }, []);

  return (
    <div>
      <Box>
        {!campaignListLoading ? (
          <>
            <div className="flex justify-between items-center px-2 ">
              <h1 className="text-[20px]">Campaigns</h1>
              <div
                className="flex justify-center items-center rounded-full px-1 py-2 space-x-2 text-sm bg-[var(--secondary-color)] text-gray-900"
                style={{ border: "1px solid var(--listdown-color)" }}
              >
                <Search color="var(--listdown-color)" />
                <input
                  type="text"
                  className="outline-none"
                  placeholder={`Search Campaign`}
                  onChange={(e) =>
                    handleSearchChangeHead(e, getHeadCells[0].id)
                  }
                  value={searchInputs?.campaignName || ""}
                />
              </div>
            </div>
            <Paper
              sx={{
                width: "100%",

                backgroundColor: "white",
                borderRadius: "20px",
              }}
              className="px-4 mt-1 pb-1"
            >
              <>
                <TableContainer
                  sx={{
                    height: "calc(85vh - 125px)", // Adjust this to control available space for the table
                    maxHeight: "calc(85vh - 125px)", // Ensures the table won't exceed this height
                    overflowY: "auto", // Adds scroll when the content exceeds height
                  }}
                  className={`mt-2 rounded-lg  ${Styles["custom-scrollbar"]}`}
                >
                  <Table
                    stickyHeader
                    // sx={{ minWidth: 750 }}
                    className="rounded-lg "
                  >
                    <EnhancedTableHead
                      rowCount={campaign.length}
                      userListData={getCampaignList}
                      setSearchInputs={setSearchInputs} // Function to update search inputs
                      handleSearchChangeHead={handleSearchChangeHead}
                      searchInputs={searchInputs}
                    />
                    {campaign && campaign?.length > 0 ? (
                      <TableBody>
                        {campaign.map((v, index) => {
                          return (
                            <TableRow
                              hover
                              key={index}
                              sx={{ cursor: "pointer", height: "60px" }}
                              tabIndex={-1}
                            >
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                {(v?.campaignTitle &&
                                  v?.campaignTitle.charAt(0).toUpperCase() +
                                    v?.campaignTitle.slice(1)) ||
                                  "NA"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                {" "}
                                <p className="text-[13px]">
                                  {formatDate(v?.rfpId?.createdAt) || "N.A"}
                                </p>
                              </TableCell>

                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                {" "}
                                {/* <div className="text-[13px]">
                                  {v.rfpId?.addedBy?.name || "NA"}
                                </div>
                                <div className="text-[--para-color] text-[12px]">
                                  {v?.rfpId.addedBy?.emailAddress || "NA"}
                                </div> */}
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                <p className="text-[13px]">
                                  {formatDate(v?.startDate)} -{" "}
                                  {formatDate(v?.endDate)}
                                </p>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                <div className="text-[13px]">
                                  {v.campaignOwnerId?.name || "NA"}
                                </div>
                                <div className="text-[--para-color] text-[12px]">
                                  {v.campaignOwnerId?.emailAddress || "NA"}
                                </div>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                {(() => {
                                  const kamDetails = getKAMName(
                                    v.keyAccountManagerId
                                  );

                                  // Handle the case where there are no KAM details
                                  if (
                                    !Array.isArray(kamDetails) ||
                                    kamDetails.length === 0
                                  ) {
                                    return <p>No KAM Assigned</p>;
                                  }

                                  // Render the KAM details
                                  return (
                                    <div>
                                      {kamDetails.map((kam, index) => (
                                        <div key={index}>
                                          <div className="text-[13px]">
                                            {kam.name || "NA"}
                                          </div>
                                          <p className="text-[--para-color] text-[12px]">
                                            {kam.email || "NA"}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  );
                                })()}
                              </TableCell>

                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                <p> {v.quantity || "0"}</p>
                              </TableCell>

                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                <p> INR {v.budget || "0"}</p>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                <div className="flex justify-center items-center">
                                  <div
                                    className="w-full bg-gray-200 rounded-full dark:bg-[#E1ECFF]"
                                    style={{ width: "6vw", height: "0.5rem" }}
                                  >
                                    <div
                                      className="bg-[var(--primary-color)] text-[12px] font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                                      style={{
                                        width: `${v.progress}%`,
                                        height: "0.5rem",
                                      }}
                                    ></div>
                                  </div>
                                  <span className="mx-2 text-[var(--heading-color)] text-[12px]">
                                    {v.progress || "NA"}%
                                  </span>
                                </div>
                              </TableCell>

                              <TableCell
                                sx={{
                                  padding: "4px 8px",
                                }}
                              >
                                {(() => {
                                  const statusConfig = {
                                    inProgress: {
                                      bgColor: "var(--yellow-bgChip-color)",
                                      textColor: "var(--textChip-yellow-color)",
                                      label: "Ongoing",
                                    },
                                    completed: {
                                      bgColor: "var(--green-bgChip-color)",
                                      textColor: "var(--textChip-green-color)",
                                      label: "Completed",
                                    },
                                    abandoned: {
                                      bgColor: "#fabeed",
                                      textColor: "var(--border-color)",
                                      label: "Cancelled",
                                    },
                                    "payment-awaited": {
                                      bgColor: "#E1ECFF",
                                      textColor: "#418CFF",
                                      label: "Payment Awaited",
                                    },
                                  };

                                  const status = statusConfig[v.status];
                                  if (!status) return null;

                                  return (
                                    <div
                                      className={`rounded-full flex items-center py-0.5 px-2.5 border border-transparent text-sm transition-all shadow-sm w-fit`}
                                      style={{
                                        backgroundColor: status.bgColor,
                                        color: status.textColor,
                                      }}
                                    >
                                      {status.label}
                                    </div>
                                  );
                                })()}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    ) : (
                      <div className="flex justify-center items-center h-64">
                        No Campaign found
                      </div>
                    )}
                  </Table>
                </TableContainer>
                <hr
                  className="mt-2 bg-gray-200 "
                  style={{ border: "0.5px solid var(--light-grey-color)" }}
                />

                <div className="flex items-center justify-between mt-3">
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{ minWidth: 80 }}
                  >
                    <InputLabel id="page-size-label">Rows</InputLabel>
                    <Select
                      labelId="page-size-label"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                      label="Rows"
                    >
                      {pageSizeOptions.map((size, index) => (
                        <MenuItem key={size} value={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Pagination
                    className="p-2 flex justify-center"
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#418cff", // Blue background for selected
                        color: "#fff", // White text for selected
                      },
                      "& .MuiPaginationItem-root.Mui-selected:hover": {
                        backgroundColor: "#3366cc", // Darker blue on hover
                      },
                      "& .MuiPaginationItem-root": {
                        "&:hover": {
                          backgroundColor: "#ddd", // Light gray for hovered items
                        },
                      },
                    }}
                  />
                </div>
              </>
            </Paper>
          </>
        ) : (
          <div className="flex justify-center items-center h-64">
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
};

export default ClientCampaignsTable;
